import React from 'react';
import PropTypes from "prop-types";
import css from "./RequestHelpModal.css";
import Modal from "react-modal";
import App from "../requestHelp/App";
import Header from "../common/Header";

const RequestHelpModal = ({
  openRequestHelpModal, studentId, closeModal, cancelButtonText, successRequestHelp, studentSelfFlaggingEnabled, requestHelpEnabled
}) =>
  (
    <Modal
      isOpen={openRequestHelpModal}
      appElement={document.getElementById('main-center')}
      onRequestClose={closeModal}
      overlayClassName={css['overlay']}
      className={css['modal']}
      contentLabel="Request Help"
      shouldCloseOnOverlayClick={false}>
      <Header closeModal={closeModal}/>
      <div className={css['container']}>
        <App isStudent studentId={studentId}
             closeModal={closeModal}
             cancelButtonText={cancelButtonText}
             successRequestHelp={successRequestHelp}
             studentSelfFlaggingEnabled={studentSelfFlaggingEnabled}
             requestHelpEnabled={requestHelpEnabled} />
      </div>
    </Modal>
  );

RequestHelpModal.propTypes = {
  openRequestHelpModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  studentId: PropTypes.number.isRequired,
  successRequestHelp: PropTypes.func.isRequired,
  studentSelfFlaggingEnabled: PropTypes.bool.isRequired,
  requestHelpEnabled: PropTypes.bool.isRequired,
  cancelButtonText: PropTypes.string
};

export default RequestHelpModal;
